module.exports = __webpack_public_path__ + "img/LUX.da28774e.svg";